module.exports = __webpack_public_path__ + "img/ai-radio.7b1b9ed7.png";